import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a2f0100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "houseRent-applyDetail" }
const _hoisted_2 = { class: "houseRent-detail-wrapper" }
const _hoisted_3 = { class: "houseRent-detail" }
const _hoisted_4 = {
  class: "item text-overflow",
  style: {"display":"flex","margin-bottom":"14px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666","margin-bottom":"0px"} }, "地址：", -1))
const _hoisted_6 = { style: {"flex":"1","margin-bottom":"0px"} }
const _hoisted_7 = {
  class: "item text-overflow",
  style: {"display":"flex","margin-bottom":"14px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666","margin-bottom":"0px"} }, "工商注册地址：", -1))
const _hoisted_9 = { style: {"flex":"1","margin-bottom":"0px"} }
const _hoisted_10 = { class: "item text-overflow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "租金(含物业费)：", -1))
const _hoisted_12 = { style: {"margin-right":"5px"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "押金：", -1))
const _hoisted_16 = { style: {"margin-right":"5px"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "item text-overflow" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "面积：", -1))
const _hoisted_20 = { style: {"margin-right":"5px"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "item text-overflow" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "可容纳人数：", -1))
const _hoisted_24 = { style: {"margin-right":"5px"} }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 租赁起止时间：", -1))
const _hoisted_28 = { class: "item text-overflow" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "租赁期限：", -1))
const _hoisted_30 = { class: "item text-overflow" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "房东联系方式：", -1))
const _hoisted_32 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "是否入驻产业园：", -1))
const _hoisted_34 = { class: "item text-overflow" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "打款方式：", -1))
const _hoisted_36 = { class: "item text-overflow" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "打款账号：", -1))
const _hoisted_38 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { houseRentDetail } from "@/api/process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean }





const Address = ref<string>("");
const BusinessRegistrationAddress = ref<string>("");
const Rent = ref<string>("");
const Deposit = ref<string>("");
const Area = ref<string>("");
const CapacityNumber = ref<string>("");
const LeaseStartDate = ref<string>("");
const LeaseEndDate = ref<string>("");
const LeaseTerm = ref<string>("");
const LandlordContact = ref<string>("");
const PaymentAccount = ref<string>("");
const PaymentWayText = ref<string>("");
const IsSettleIndustrialPark = ref<string>("");

watch(
  () => props.update,
  (val, oldValue) => {
    if (val !== oldValue) {
      getdata();
    }
  }
  // { immediate: true }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

const getdata = async () => {
  const { Data } = await houseRentDetail({
    Id: props.folwId,
    IsApproveDetail: 1,
  });

  if (Data?.BackPageFiles.length > 0) {
    tableData.value = [
      ...(Data?.PageFiles || []),
      ...(Data?.BackPageFiles || []),
    ];
  } else {
    tableData.value = Data?.PageFiles;
  }
  // 房屋租赁表单--新增
  Address.value = Data?.Data?.Address || "";
  BusinessRegistrationAddress.value =
    Data?.Data?.BusinessRegistrationAddress || "";
  Rent.value = Data?.Data?.Rent || "";
  Deposit.value = Data?.Data?.Deposit || "";
  Area.value = Data?.Data?.Area || "";
  CapacityNumber.value = Data?.Data?.CapacityNumber || "";
  LeaseStartDate.value = Data?.Data?.LeaseStartDate || "";
  LeaseEndDate.value = Data?.Data?.LeaseEndDate || "";
  LeaseTerm.value = Data?.Data?.LeaseTerm || "";
  LandlordContact.value = Data?.Data?.LandlordContact || "";
  PaymentAccount.value = Data?.Data?.PaymentAccount || "";
  PaymentWayText.value = Data?.Data?.PaymentWayText || "";
  IsSettleIndustrialPark.value = Data?.Data?.IsSettleIndustrialPark || "";

  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime
  });
};

onMounted(async () => {
  getdata();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "房屋租赁等合同申请",
      style: {"margin-top":"24px"}
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(Address.value), 1)
          ]),
          _createElementVNode("span", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(BusinessRegistrationAddress.value), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(Rent.value), 1),
            (Rent.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "元"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(Deposit.value), 1),
            (Deposit.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "元"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("span", _hoisted_20, _toDisplayString(Area.value), 1),
            (Area.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "平方米"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(CapacityNumber.value), 1),
            (CapacityNumber.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "人"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("span", null, _toDisplayString(LeaseStartDate.value) + " - " + _toDisplayString(LeaseEndDate.value), 1)
          ]),
          _createElementVNode("span", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", null, _toDisplayString(LeaseTerm.value), 1)
          ]),
          _createElementVNode("span", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("span", null, _toDisplayString(LandlordContact.value), 1)
          ]),
          _createElementVNode("span", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("span", null, _toDisplayString(IsSettleIndustrialPark.value == 1
              ? "是"
              : IsSettleIndustrialPark.value == 2
              ? "否"
              : ""), 1)
          ]),
          _createElementVNode("span", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", null, _toDisplayString(PaymentWayText.value), 1)
          ]),
          _createElementVNode("span", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("span", null, _toDisplayString(PaymentAccount.value), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})